/* Calma PDP — generyczny init dla wszystkich wersji PDP (?view=a/b/c).
   Bez zależności. Obsługuje dowolną liczbę instancji na stronie.
   - [data-calma-buybox]: radio name="id" z data-price/data-econ-apps/data-econ-cost
     → aktualizuje [data-price-display], [data-econ-apps], [data-econ-cost] w obrębie buyboxa
       oraz sticky pasek wskazany przez data-sticky-target="#id".
   - [data-calma-gallery]: [data-thumb] przełącza [data-main-frame]. */
(function () {
  // Znajdź galerię powiązaną z buyboxem (ta sama sekcja / ten sam hero).
  function findGalleryFor(box) {
    var scope = box.closest('.pc-hero') || box.closest('section') || document;
    return scope.querySelector('[data-calma-gallery]');
  }

  // Nazwa pliku bez query (porównanie obrazów niezależnie od width/v=).
  function imgKey(url) {
    if (!url) return '';
    var s = String(url).split('?')[0];
    var slash = s.lastIndexOf('/');
    return slash >= 0 ? s.slice(slash + 1) : s;
  }

  function showFrameIndex(gal, idx) {
    gal.dispatchEvent(new CustomEvent('calma:gallery-show', { detail: { index: idx } }));
  }

  // Pokaż w galerii zdjęcie pasujące do wariantu.
  // 1) variant.featured_image (data-image) → ramka z tym samym plikiem,
  // 2) heurystyka po pojemności (data-vol) → ramka, której plik zawiera token (np. "-200"),
  // 3) fallback: podmień src aktywnej ramki na obraz wariantu.
  function showVariantMedia(gal, input) {
    if (!gal) return;
    var frames = gal.querySelectorAll('[data-main-frame]');
    var i;
    // 1) dokładne dopasowanie po obrazie wariantu
    if (input.dataset.image) {
      var want = imgKey(input.dataset.image);
      for (i = 0; i < frames.length; i++) {
        if (imgKey(frames[i].getAttribute('data-src')) === want) {
          showFrameIndex(gal, frames[i].getAttribute('data-main-frame'));
          return;
        }
      }
    }
    // 2) dopasowanie po pojemności (gdy warianty nie mają przypisanych zdjęć w adminie)
    var vol = input.dataset.vol;
    if (vol) {
      for (i = 0; i < frames.length; i++) {
        var key = imgKey(frames[i].getAttribute('data-src'));
        if (key.indexOf('-' + vol) !== -1 || key.indexOf(vol + 'ml') !== -1) {
          showFrameIndex(gal, frames[i].getAttribute('data-main-frame'));
          return;
        }
      }
    }
    // 3) ostatnia deska ratunku
    if (input.dataset.image) {
      var active = gal.querySelector('[data-main-frame]:not([hidden]) img');
      if (active) { active.removeAttribute('srcset'); active.src = input.dataset.image; }
    }
  }

  // Galeria per pojemność: pokaż tylko ramki/miniatury pasujące do wariantu.
  // data-cap ('100'|'200'|'') ; '' = wspólne. vol = data-vol radia. Brak vol → wszystko.
  function filterGallery(gal, vol) {
    if (!gal) return;
    var frames = gal.querySelectorAll('[data-main-frame]');
    var thumbs = gal.querySelectorAll('[data-thumb]');
    function match(el) {
      var c = el.getAttribute('data-cap') || '';
      return !vol || c === '' || c === String(vol);
    }
    var first = null, activeVisible = false;
    frames.forEach(function (f) {
      var ok = match(f);
      if (ok && first === null) first = f.getAttribute('data-main-frame');
      if (ok && !f.hidden) activeVisible = true;
      if (!ok) f.hidden = true;
    });
    thumbs.forEach(function (t) { t.style.display = match(t) ? '' : 'none'; });
    if (first != null && !activeVisible) {
      gal.dispatchEvent(new CustomEvent('calma:gallery-show', { detail: { index: first } }));
    }
  }

  // Zestaw: przelicz oszczędność per pojemność (100/200) na podstawie data-zset.
  function updateZset(vol) {
    var z = document.querySelector('[data-zset]');
    if (!z || !vol) return;
    var save = z.getAttribute('data-save-' + vol);
    var was = z.getAttribute('data-was-' + vol);
    var sEl = z.querySelector('[data-zset-save]');
    var wEl = z.querySelector('[data-zset-was]');
    if (save && sEl) sEl.textContent = save;
    if (was && wEl) wEl.textContent = was;
  }

  function getCartDrawer() {
    var d = document.querySelector('cart-drawer-component');
    return d && typeof d.open === 'function' ? d : null;
  }

  function openCartDrawer() {
    var d = getCartDrawer();
    if (!d) return false;
    try { d.open(); return true; } catch (err) { return false; }
  }

  function initBuybox(box) {
    var disp = box.querySelector('[data-price-display]');
    var apps = box.querySelector('[data-econ-apps]');
    var cost = box.querySelector('[data-econ-cost]');
    var stickyId = box.getAttribute('data-sticky-target');
    var sticky = stickyId ? document.querySelector(stickyId) : null;
    var stickyP = sticky ? sticky.querySelector('[data-sticky-price]') : null;
    var gal = findGalleryFor(box);
    box.querySelectorAll('input[name="id"]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (r.dataset.price) {
          if (disp) disp.textContent = r.dataset.price;
          if (stickyP) stickyP.textContent = r.dataset.price;
        }
        if (apps && r.dataset.econApps) apps.textContent = r.dataset.econApps;
        if (cost && r.dataset.econCost) cost.textContent = r.dataset.econCost;
        filterGallery(gal, r.dataset.vol);
        updateZset(r.dataset.vol);
      });
      if (r.checked) { filterGallery(gal, r.dataset.vol); updateZset(r.dataset.vol); }
    });

    // AJAX add-to-cart (bez przeładowania) — działa dla głównego CTA i sticky.
    // Po dodaniu otwiera szufladę koszyka z odświeżoną treścią (sekcje z /cart/add.js, jak natywny formularz Horizon).
    // Bez szuflady (strona /cart, koszyk jako strona) zostaje link do /cart.
    var form = box.querySelector('form');
    var mainBtn = box.querySelector('.calma-bb__add');
    var stickyBtn = sticky ? sticky.querySelector('.calma-sticky__add') : null;
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btns = [mainBtn, stickyBtn].filter(Boolean);
        btns.forEach(function (b) { if (!b.dataset.label) b.dataset.label = b.textContent; b.disabled = true; b.textContent = 'Dodawanie…'; });
        var fd = new FormData(form);
        var sectionIds = [];
        document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) { sectionIds.push(c.dataset.sectionId); });
        if (sectionIds.length) { fd.append('sections', sectionIds.join(',')); fd.append('sections_url', window.location.pathname); }
        var sections = null;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/javascript' }, body: fd })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function (added) {
            sections = added && added.sections ? added.sections : null;
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; });
          })
          .then(function (cart) {
            if (cart && typeof cart.item_count === 'number') {
              var data = { itemCount: cart.item_count, source: 'calma-pdp' };
              if (sections) data.sections = sections;
              document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'calma-pdp', data: data } }));
            }
            var opened = openCartDrawer();
            btns.forEach(function (b) { b.disabled = false; b.textContent = 'W koszyku ✓'; });
            if (mainBtn && !box.querySelector('[data-goto-cart]')) {
              var g = document.createElement('a');
              g.className = 'calma-bb__goto'; g.setAttribute('data-goto-cart', ''); g.href = '/cart';
              g.textContent = getCartDrawer() ? 'Zobacz koszyk →' : 'Przejdź do koszyka →';
              g.addEventListener('click', function (ev) { if (openCartDrawer()) ev.preventDefault(); });
              mainBtn.insertAdjacentElement('afterend', g);
            }
            setTimeout(function () { btns.forEach(function (b) { if (b.textContent === 'W koszyku ✓') b.textContent = b.dataset.label || 'Dodaj do koszyka'; }); }, opened ? 600 : 2500);
          })
          .catch(function () {
            btns.forEach(function (b) { b.disabled = false; b.textContent = b.dataset.label || 'Dodaj do koszyka'; });
            window.location.href = '/cart';
          });
      });
    }
  }

  function initGallery(gal) {
    var frames = gal.querySelectorAll('[data-main-frame]');
    var thumbs = gal.querySelectorAll('[data-thumb]');
    function show(i) {
      frames.forEach(function (f) { f.hidden = (f.getAttribute('data-main-frame') !== String(i)); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(i)); });
    }
    thumbs.forEach(function (t) {
      var i = t.getAttribute('data-thumb');
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(i); }
      });
    });
    // Sterowanie z zewnątrz (np. wybór wariantu w buyboxie).
    gal.addEventListener('calma:gallery-show', function (e) {
      if (e.detail && e.detail.index != null) show(e.detail.index);
    });

    // 20.10: na telefonie przesuwanie palcem po dużym zdjęciu + licznik „1 / 4”
    // (klienci przesuwają zdjęcie, a nie stukają w miniatury). Kolejność = widoczne miniatury.
    var main = gal.querySelector('.calma-gal__main');
    if (!main || thumbs.length < 2) return;
    var counter = document.createElement('span');
    counter.className = 'calma-gal__count';
    counter.setAttribute('aria-hidden', 'true');
    main.appendChild(counter);
    function visibleThumbs() {
      return Array.prototype.filter.call(thumbs, function (t) { return t.style.display !== 'none'; });
    }
    function activePos(list) {
      for (var k = 0; k < list.length; k++) { if (list[k].classList.contains('is-active')) return k; }
      return 0;
    }
    function updateCounter() {
      var list = visibleThumbs();
      counter.textContent = (activePos(list) + 1) + ' / ' + list.length;
      counter.hidden = list.length < 2;
    }
    var origShow = show;
    show = function (i) { origShow(i); updateCounter(); };
    function step(d) {
      var list = visibleThumbs();
      if (list.length < 2) return;
      var next = list[(activePos(list) + d + list.length) % list.length];
      show(next.getAttribute('data-thumb'));
      if (next.scrollIntoView) next.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    var x0 = null, y0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) step(dx < 0 ? 1 : -1);
    }, { passive: true });
    // filtr pojemności (calma-pdp: filterGallery) zmienia widoczne miniatury → odśwież licznik
    gal.addEventListener('calma:gallery-show', updateCounter);
    setTimeout(updateCounter, 0);
  }

  function init() {
    // Galerie najpierw — buybox przy inicjalizacji może wysłać event 'calma:gallery-show'.
    document.querySelectorAll('[data-calma-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-calma-buybox]').forEach(initBuybox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
